import { Link, type LinkProps } from "@tanstack/react-router";
import { Card, EmptyState, Icon } from "@/deps/ui-library";
import type { Permission } from "@/api/types";
import { deniedMessage } from "@/lib/permissions";

/** Design: "Permission denied" (lines 1149–1159). */
export function PermissionDeniedPage({
  permission,
  backTo,
  backLabel,
}: {
  permission: Permission;
  backTo: LinkProps["to"];
  backLabel: string;
}) {
  return (
    <section className="px-6 py-5 max-w-[1280px] w-full mx-auto">
      <Card variant="outlined" size="none">
        <EmptyState
          config={{ size: "sm", variant: "warning" }}
          icon={<Icon name="ShieldAlert" size="md" />}
          title={deniedMessage(permission)}
          description="Ask an administrator to change your role in Settings · Users."
        >
          <Link
            to={backTo}
            className="text-sm text-primary font-medium no-underline hover:underline"
          >
            {backLabel}
          </Link>
        </EmptyState>
      </Card>
    </section>
  );
}
